module.exports = __webpack_public_path__ + "img/decoration-07.4f413e4.svg";